export enum PLATFORMS {
  Android = 'android',
  XSELL = 'xsell',
  Desktop = 'desktop',
  MobileWeb = 'mobile_web',
}

export const PRODUCTS = {
  CASINO: 'casino',
  XSELL: 'xsell',
  POKER: 'poker',
};

export const BRANDS = {
  FANDUEL: 'fanduel',
  MOHEGANSUN: 'mohegansun',
};
